<script>
  export default{
    props: {
      height: {  // 加载框高度
        type: Number,
        default: 300
      },
      itemHeight: {  // 加载圈圈的高度
        type: Number,
        default: 40
      },
      itemTop: {  // 加载圈圈的定位距离
        type: Number,
        default: 120
      },
      textTop: {  // 文字定位距离
        type: Number,
        default: 165
      },
    }
  }
</script>

<template>
    <div class="loading-wapper" :style="{height:height+'px'}">
      <div class="loading-item" :style="{height:itemHeight+'px',width:itemHeight+'px',top: itemTop + 'px'}"></div>
      <div class="loading-text" :style="{top: textTop + 'px'}">Loading...</div>
    </div>
</template>

<style scoped lang="scss">
.loading-wapper {
  width: 100%;
  height: 300px;
  position: relative;

  .loading-text {
    position: absolute;
    z-index: 11999;
    top: 165px;
    left: calc(50% - 25px);
    color: #333333;
    font-size: 14px;
  }

  .loading-item {
    position: absolute;
    z-index: 11999;
    top: 120px;
    left: calc(50% - 25px);
    width: 40px;
    height: 40px;
    border: 5px solid #fff;
    border-top-color: #FF7D3F;
    border-left-color: #e37674;
    border-radius: 50%;
    animation: 10s infinite fadenum linear;
  }

  @keyframes fadenum {
    100% {
      transform: rotate(9000deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue